import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';
import { ShopInformationFileTypes } from 'interfaces';

export type ShopInformationFile = {
  shop_information_file_id?: number; // 쇼/브/매/지 파일 idx
  shop_information_id?: number; // 쇼/브/매/지 idx
  file_name?: string; // 파일명
  file_url?: string; // 파일 주소
  type?: (typeof ShopInformationFileTypes)[keyof typeof ShopInformationFileTypes]; // 파일 타입
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] ShopInformationFile
   * --
   */
  getShopInformationFiles: async (params?: {
    [key: string]: string | number;
  }) => {
    try {
      const res = await $http.get(APIConstant.GETS_SHOP_FILE, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] ShopInformationFile
   * --
   */
  getShopInformationFile: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_SHOP_FILE, {
        shop_information_file_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] ShopInformationFile
   * --
   */
  createShopInformationFile: async (body: ShopInformationFile) => {
    try {
      const res = await $http.post(APIConstant.CREATE_SHOP_FILE, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] ShopInformationFile
   * --
   */
  updateShopInformationFile: async (body: ShopInformationFile) => {
    try {
      const { shop_information_file_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_SHOP_FILE, {
        shop_information_file_id: shop_information_file_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] ShopInformationFile
   * --
   */
  deleteShopInformationFile: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.DELETE_SHOP_FILE, {
        shop_information_file_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
